import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Brand } from '@clearcover/atlas';
import styles from './styles.module.css';

export const SecondaryMenu: FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const navVariants = {
    closed: {
      x: -256,
      opacity: 0,
      transition: { when: 'afterChildren' },
    },
    open: {
      transition: { duration: 0.3, staggerChildren: 0.2 },
      x: 0,
      opacity: 1,
    },
  };

  return (
    <motion.div
      initial="closed"
      animate="open"
      variants={navVariants}
      className={styles.container}
      data-testid="secondary-menu"
    >
      <div className={styles.logo}>
        <Brand color="white" />
      </div>
      <div className={styles.items}>{children}</div>
    </motion.div>
  );
};

const itemVariants = {
  open: {
    opacity: 1,
  },
  closed: {
    opacity: 0,
  },
};

export const SecondaryMenuLink: React.FC<{
  item: {
    path: string;
    name: string;
    testId?: string;
  };
}> = ({ item }) => (
  <motion.div
    whileHover={{ scale: 1.03 }}
    whileTap={{ scale: 0.97 }}
    variants={itemVariants}
    key={item.path}
  >
    <NavLink
      to={item.path}
      className={styles.route}
      activeClassName={styles.active}
      data-testid={item.testId}
    >
      <div className={styles.linkContainer}>
        <div className={styles.icon} />
        <div className={styles.text}>{item.name}</div>
      </div>
    </NavLink>
  </motion.div>
);
